import { StudentProfile } from './StudentProfile';

export default StudentProfile;
